<template>
  <span class="base-pseudo-link" :class="classes">
    <slot />
  </span>
</template>

<script setup lang="ts">
interface Props {
  variant?: 'primary' | 'secondary'
  cursor?: 'pointer' | 'not-allowed'
  withUnderline?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  cursor: 'pointer',
  withUnderline: false,
})
const classes = computed(() => [
  `base-pseudo-link--variant-${props.variant}`,
  {
    'base-pseudo-link--with-underline': props.withUnderline,
  },
])
</script>

<style lang="scss" scoped>
.base-pseudo-link {
  cursor: v-bind(cursor);

  &--variant {
    &-primary {
      color: var(--color-foreground-primary);
    }

    &-secondary {
      color: var(--color-foreground-caption);
    }
  }

  &--with-underline {
    text-decoration: underline;
  }
}
</style>
